import {useContext} from "react";
import {IStores} from "../types/IStores";
import {StoreContext} from "../index";

export function useStore(): IStores {
    return useContext<IStores>(StoreContext);
}